import React from 'react';

const CalendarDates = ({ width = 20, height = 20, color = '#424242', ...rest }) => {
  return (
    <svg {...rest} width={width} height={height} viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5835 1.70703V3.89453"
        stroke={color}
        strokeWidth="1.05"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4165 1.70703V3.89453"
        stroke={color}
        strokeWidth="1.05"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.30225 6.875H15.6981"
        stroke={color}
        strokeWidth="1.05"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0625 6.44661V12.6445C16.0625 14.832 14.9688 16.2904 12.4167 16.2904H6.58333C4.03125 16.2904 2.9375 14.832 2.9375 12.6445V6.44661C2.9375 4.25911 4.03125 2.80078 6.58333 2.80078H12.4167C14.9688 2.80078 16.0625 4.25911 16.0625 6.44661Z"
        stroke={color}
        strokeWidth="1.05"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1911 10.2396H12.1977"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1911 12.4271H12.1977"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.49583 10.2396H9.50238"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.49583 12.4271H9.50238"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.80052 10.2396H6.80707"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.80052 12.4271H6.80707"
        stroke={color}
        strokeWidth="1.3125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalendarDates;
